<nz-spin [nzSpinning]="loading" [nzTip]="dataMsg">
  <form [formGroup]="form" class="form" nz-form [nzLayout]="'vertical'">
    <div class="row" style="display: flex; gap: 16px; flex-wrap: wrap">
      <div class="col" style="flex: 1 1 45%">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="invoice_number">Bill Number</nz-form-label>
          <nz-form-control nzErrorTip="Invoice number is required">
            <input nz-input formControlName="invoice_number" name="invoice_number" />
          </nz-form-control>
        </nz-form-item>

        <div class="row" style="display: flex; gap: 16px; flex-wrap: wrap">
          <div style="flex: 1 1 45%">
            <nz-form-item>
              <nz-form-label nzRequired nzFor="issue_date">Issue Date</nz-form-label>
              <nz-form-control nzErrorTip="Issue date is required">
                <nz-date-picker formControlName="issue_date" name="issue_date" style="width: 100%;"></nz-date-picker>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div style="flex: 1 1 45%">
            <nz-form-item>
              <nz-form-label nzRequired nzFor="due_date">Due Date</nz-form-label>
              <nz-form-control nzErrorTip="Due date is required">
                <nz-date-picker formControlName="due_date" name="due_date" style="width: 100%;"></nz-date-picker>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="row" style="display: flex; gap: 16px; flex-wrap: wrap">
          <div style="flex: 1 1 45%">
            <nz-form-item>
              <nz-form-label nzRequired nzFor="currency_type">Currency Type</nz-form-label>
              <nz-form-control nzErrorTip="Currency type is required">
                <nz-select nzShowSearch nzAllowClear formControlName="currency_type" id="currency_type"
                  nzPlaceHolder="Select currency">
                  <nz-option *ngFor="let c of currencies" name="currency_type" [nzValue]="c.id"
                    [nzLabel]="c.symbol"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div style="flex: 1 1 45%">
            <nz-form-item>
              <nz-form-label nzRequired nzFor="total_amount">Total Amount</nz-form-label>
              <nz-form-control nzErrorTip="Total amount is required">
                <input nz-input type="number" name="total_amount" formControlName="total_amount" />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="row" style="display: flex; gap: 16px; flex-wrap: wrap">
          <div style="flex: 1 1 45%">
            <nz-form-item>
              <nz-form-label nzRequired nzFor="usd_currency_exchange_rate"> Exchange Rate</nz-form-label>
              <nz-form-control nzErrorTip="Exchange rate is required">
                <nz-input-group [nzAddOnAfter]="addOnAfterTemplate">
                  <input nz-input type="number" name="usd_currency_exchange_rate"
                    formControlName="usd_currency_exchange_rate" />
                </nz-input-group>
                <ng-template #addOnAfterTemplate>
                  <button nz-button nzType="text" class="converter" (click)="fetchConvertion()">
                    <nz-icon nzType="reload" [nzSpin]="loadingConversion" nzTheme="outline" />
                  </button>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div style="flex: 1 1 45%">
            <nz-form-item>
              <nz-form-label nzFor="amount_paid_usd">Amount Paid (USD)</nz-form-label>
              <nz-form-control>
                <input nz-input type="number" name="amount_paid_usd" formControlName="amount_paid_usd" />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <nz-form-item>
          <nz-form-label nzFor="status" nzRequired>Status</nz-form-label>
          <nz-form-control nzErrorTip="Status is required">
            <nz-select nzShowSearch nzAllowClear formControlName="status" id="status" nzPlaceHolder="Select status">
              <nz-option *ngFor="let c of status" [nzValue]="c.id" [nzLabel]="c.name"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>


      </div>

      <div class="col" style="flex: 1 1 45%">



        <nz-form-item>
          <nz-form-label nzRequired nzFor="vendor_submission">Vendor Submission</nz-form-label>
          <nz-form-control>
            <ng-container *ngIf="isEditMode; else showSelect">
              <input nz-input disabled [value]=" eventId?.eventData?.vendor_details.name" style="color: rgb(0 0 0);" />
            </ng-container>
            <ng-template #showSelect>
              <nz-select formControlName="vendor_submission" id="vendor_submission" nzShowSearch nzAllowClear
                nzPlaceHolder="Select a vendor submission">
                <nz-option *ngFor="let q of vendorSubmissions" name="vendor_submission" [nzValue]="q.id"
                  [nzLabel]="formatIdToFourDigits(q.id, 'QR') + ' - ' + (q.quotation_request_vendor_details?.vendor_details?.name || q.vendor_details?.name || q.name)"></nz-option>
              </nz-select>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <!--     [nzLabel]=" formatIdToFourDigits(q.id, 'QR') + ' - ' + q.request_title" -->





        <!-- <nz-form-item>
  <nz-form-label [nzRequired]="true" nzFor="event">Event</nz-form-label>
  <nz-form-control nzErrorTip="Event is required">
    <nz-select formControlName="event" id="event"  nzPlaceHolder="Select an event">
      <nz-option *ngFor="let e of events" name="event" [nzValue]="e.id" [nzLabel]="e.name"></nz-option>
    </nz-select>
  </nz-form-control>
</nz-form-item> -->

        <nz-form-item>
          <nz-form-label nzFor="description">Description</nz-form-label>
          <nz-form-control>
            <textarea nz-input rows="5" name="description" formControlName="description"></textarea>
          </nz-form-control>
        </nz-form-item>


        <nz-form-item>
          <nz-form-label>Files</nz-form-label>
          <nz-form-control class="fileUpload">
            <nz-upload [nzSize]="5242880" [nzCustomRequest]="customUploadRequest" nzListType="picture"
              [nzDownload]="handleDownload" [nzBeforeUpload]="beforeUpload" (nzChange)="onUploadChange($event)"
              [(nzFileList)]="fileList">
              <button nz-button (click)="downloadFile($event)">
                <i nz-icon nzType="paper-clip"></i> Attach Files
              </button>
            </nz-upload>
            <p style="font-size:10px;font-weight: 500;font-style: italic;color:grey;
          position:absolute;right:10px;top:-25px"> Accepted formats: .pdf, .jpeg, .jpg etc. (Add max file size 5 MB)
            </p>
          </nz-form-control>
        </nz-form-item>



        <button style="float: inline-end;" nz-button nzType="primary" (click)="onSubmit()" [disabled]="form.invalid">
          {{eventId?.eventData?.id ? 'Update' : 'Submit'}} </button>
      </div>
    </div>
  </form>
</nz-spin>